<template>
  <div class="collection">
    <van-uploader multiple :after-read="afterRead" accept="image/*,.pdf,.zip,.doc,.docx,.ppt,.txt,.xls,.xlsx,.ofd">
      <slot name="gather" />
    </van-uploader>
  </div>
</template>
<script>
import { Uploader, Toast } from 'vant'
import UploadService from '@services/UploadService'
export default {
  components: {
    [Uploader.name]: Uploader
  },
  data () {
    return {
      paths: [],
      filesList: 0
    }
  },
  props: {
    callBack: {
      type: Function,
      default: () => {}
    }
  },
  watch: {
    paths: {
      handler (v) {
        if (this.filesList === v.length) {
          Toast.clear({
            clearAll: true
          })
          this.callBack(v)
        }
      },
      deep: true
    }
  },
  methods: {
    upService (file) {
      UploadService(file.file, this.functionPoint).then(data => {
        if (data.code === '200') {
          // this.$emit('finishUpload', data, file)
          this.paths.push(data.fileUrl)
          file.status = 'done'
          file.message = '上传成功'
        } else {
          file.status = 'failed'
          file.message = data.message
          this.$emit('finishUpload', {
            success: false,
            ...data
          })
        }
        this.fileListInside = []
      }).catch(e => {
        this.fileListInside = []
        file.status = 'failed'
        file.message = e
        this.$props.finishUpload && this.$props.finishUpload({ success: false, ...e })
      })
    },
    async afterRead (file) {
      Toast.loading({
        message: '正在采集...',
        forbidClick: true,
        duration: 0
      })
      let newFile = []
      if (!Array.isArray(file)) {
        newFile.push(file)
      } else {
        newFile = file
      }
      this.filesList = newFile.length
      this.paths = []
      file.status = 'uploading'
      file.message = '上传中...'
      await new Promise((resolve) => {
        newFile.forEach(item => {
          this.upService(item)
        })
        if (newFile.length === this.paths.length) {
          resolve()
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.collection{
  // background: red;
  /deep/.van-uploader__upload{
    background: #2372FF;
    border-radius: 50%;
    width: 100px;
    height: 100px;
    .van-icon{
      font-size: 38px;
      color: #fff;
    }
  }
}
</style>
